

import { pageStatus } from './page_status.reducer'
import { user } from './user.reducer'

const reducers = {
  pageStatus,
  user
}
export default reducers